import "@grapecity/wijmo.styles/wijmo.css";
import "@grapecity/wijmo.cultures/wijmo.culture.ko";
import styles from "./E3WijmoSheet.module.css";

import * as React from "react";
import PropTypes from "prop-types";

import { CollectionView, asEnum, saveFile, addClass, removeClass } from "@grapecity/wijmo";
import { CellType, DataMap, SelectionMode, CellRange, CellRangeEventArgs } from "@grapecity/wijmo.grid";
import { FlexGrid, FlexGridColumn } from "@grapecity/wijmo.react.grid";
import { CellMaker } from "@grapecity/wijmo.grid.cellmaker";
import { FlexGridFilter } from "@grapecity/wijmo.react.grid.filter";
import * as wjcGridXlsx from "@grapecity/wijmo.grid.xlsx";
import * as wjcXlsx from "@grapecity/wijmo.xlsx";
import * as wjGrid from "@grapecity/wijmo.grid";

import { validate, getValidateObject, getObjectFromYml } from "e3-common/utils/validationUtil";

import {
  InputDate,
  InputTime,
  //ComboBox,
  AutoComplete,
  InputColor,
  InputNumber,
} from "@grapecity/wijmo.input";
import { getLocalStorageItem, setLocalStorageItem } from "e3-common/utils/localStorageUtil";
import { E3Button } from "e3-components";
import { toggleClass, isNumber } from "@grapecity/wijmo";
import { Globalize } from "@grapecity/wijmo";
import _ from "lodash";
import { FlexSheet, Sheet } from "@grapecity/wijmo.react.grid.sheet";
import { ComboBox, ColorPicker } from "@grapecity/wijmo.react.input";
import { LOCAL_STORAGE_KEYS } from "e3-common/constants/enumerates";
import uuid from "react-uuid";

class E3WijmoSheet extends React.Component {
  useRefInput = React.createRef(FlexSheet);
  useRefDivFilter = React.createRef(FlexSheet);
  useRefEditDiv = React.createRef(FlexSheet);
  useRefColorPicker = React.createRef(FlexSheet);
  useRefApplyFillColor = React.createRef(FlexSheet);
  useRefUpdatingSelection = React.createRef(FlexSheet);
  refGrid = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      chkProp: props,
      grid: null,
      source: props.source,
      data: props.data,
      columns: props.columns,
      columnGroups: props.columnGroups,
      allowAddNew: props.allowAddNew,
      allowDelete: props.allowDelete,
      allowPinning: props.allowPinning,
      selectionMode: props.selectionMode,
      onRowClick: props.onRowClick,
      onRowDoubleClick: props.onRowDoubleClick,
      sortDescriptions: props.sortDescriptions,
      groupDescriptions: props.groupDescriptions,
      trackChanges: props.trackChanges,
      filter: props.filter,
      style: props.style,
      width: props.width,
      height: props.height,
      codeList: [],
      frozenRows: props.frozenRows,
      frozenColumns: props.frozenColumns,
      combo: null,
      comboBoxData: "None,Cell,CellRange,Row,RowRange,ListBox".split(","),
      allowMerging: props.allowMerging,
      isReadOnly: props.isReadOnly,
      exportExcel: props.exportExcel,
      defaultColumn: props.defaultColumn,
      onCellUpdate: props.onCellUpdate,
      onCellEditEnding: props.onCellEditEnding,
      onCellEditEnded: props.onCellEditEnded,
      onRowAdded: props.onRowAdded,
      onDeletingRow: props.onDeletingRow,
      beginningEdit: props.beginningEdit,
      sortedColumn: props.sortedColumn,
      validateInfo: null,
      gridId: null,
      onloadedRows: props.onloadedRows,
      onFormatItem: props.onFormatItem,
      isSearchFilter: props.isSearchFilter,
      isDragColumn: props.isDragColumn,
      isAutoRowHeights: props.isAutoRowHeights,
      onSelectedSheetChanged: props.onSelectedSheetChanged,
      cellEditStyle: [],
      onSaveStyle: props.onSaveStyle,
    };

    this.clicks = 0;
  }

  shouldComponentUpdate(nextProps) {
    if (this.props == nextProps) this.props = nextProps;
    else return false;
    return true;
  }

  render() {
    return (
      <div className={styles.container}>
        {this.props.isInputFilter ? (
          <div
            ref={this.useRefDivFilter}
            className={`input-group`}
            style={{ overflow: `hidden`, whiteSpace: `nowrap` }}
          >
            {(this.state.columnGroups?.length > 0
              ? this.setFlatColumnGroups(this.state.columnGroups)
              : this.state.columns
            ).map((element, index, array) => (
              <input
                key={
                  (this.props.gridId ? this.props.gridId : `grid`) + `_` + String(element.binding) + `_` + String(index)
                }
                className={`form-control`}
                style={{
                  width: element.width,
                  display: element.visible === false ? `none` : `float`,
                }}
                onKeyUp={(e) => {
                  let filter = e.target.value?.toLowerCase(),
                    grid = this.refGrid.current,
                    rows = grid.rows;
                  for (let i = 0; i < rows.length; i++) {
                    let row = rows[i],
                      state = row.dataItem;
                    if (state == null) return;
                    let stateVisible = String(state[element.binding]).toLowerCase().indexOf(filter) >= 0;
                    if (stateVisible) row.visible = true;
                    else row.visible = false;
                  }
                }}
              />
            ))}
          </div>
        ) : null}

        <FlexSheet
          initialized={this.flexInitialized.bind(this)}
          //itemsSource={this.state.source}
          selectionMode={this.state.selectionMode}
          allowPinning={this.state.allowPinning}
          allowAddNew={this.state.allowAddNew}
          allowDelete={this.state.allowDelete}
          quickAutoSize={this.state.quickAutoSize}
          allowMerging={this.state.allowMerging}
          isReadOnly={this.state.isReadOnly}
          frozenRows={this.state.frozenRows}
          frozenColumns={this.state.frozenColumns}
          autoRowHeights={this.state.isAutoRowHeights}
          selectionChanged={() => {
            // this.state.onRowClick && this.state.onRowClick();
          }}
          formatItem={(sender, args) => {
            // ROW STATUS에 CSS 적용 (상태별 아이콘)
            const item = sender.rows[args.row]?.dataItem;
            if (
              item > "" &&
              item.hasOwnProperty("ROW_STATUS") &&
              sender._cols[args.col]?.binding == "ROW_STATUS" &&
              args._p._rng._row >= 0
            ) {
              switch (item.ROW_STATUS) {
                case 1:
                  args.cell.className = "wj-cell grid-row-insert";
                  break;
                case 2:
                  args.cell.className = "wj-cell grid-row-update";
                  break;
                case 4:
                  args.cell.className = "wj-cell grid-row-delete";
                  break;
                default:
                  args.cell.className = "wj-cell";
                  break;
              }
            }

            const chkValue = this.props.chkValue;

            if (!chkValue) return;

            if (item) {
              const result = Object.entries(chkValue)
                .map(([key, patternObject]) => {
                  return patternObject[item?.[key]];
                })
                .filter(Boolean);

              if (args.panel.cellType === CellType.Cell) {
                if (result.length) {
                  this.setToggleClass(args.cell, result, true); // 특정 데이터 행의 className 적용
                } else {
                  this.setToggleClass(args.cell, "", true);
                }
              }
            }
          }}
          style={
            this.state.style || {
              width: typeof this.props.width === "number" ? this.props.width + "px" : this.props.width,
              height:
                typeof this.props.height === "number"
                  ? Number(this.props.height) < 100
                    ? 27 * this.props.height + "px"
                    : this.props.height + "px"
                  : this.props.height, //27: heder size
            }
          }
          childItemsPath={this.props.childItemsPath}
          {...(this.chkArray(this.state.columnGroups)
            ? {
                columnGroups: this.settingColumnGroups(this.state.columnGroups),
              }
            : {})}
        >
          <Sheet name="defaultSheet" />

          {this.state.filter && <FlexGridFilter />}
          {!this.chkArray(this.state.columnGroups) &&
            this.chkArray(this.state.columns) &&
            this.state.columns.map((column, idx) => {
              let tmpDataMap = column.dataMap
                ? new DataMap(column.dataMap, column.dataMapCode, column.dataMapValue)
                : null;

              return (
                <FlexGridColumn
                  key={idx}
                  header={column.header}
                  binding={column.binding}
                  width={column.width ? column.width : "*"}
                  align={column.align}
                  isReadOnly={column.isReadOnly}
                  isRequired={column.isRequired}
                  visible={column.visible}
                  format={column.format}
                  dataType={column.dataType}
                  dataMap={tmpDataMap}
                  dataMapEditor={column.dataMapEditor}
                  allowMerging={column.allowMerging}
                  multiLine={column.multiLine}
                  cellTemplate={
                    column.dataType?.inputColor
                      ? '<span class="colorbox" style="background:${text};"></span> ${text}'
                      : column.isButton
                      ? CellMaker.makeButton({
                          click: (e, ctx) => {
                            column.clickEvent(e, ctx);
                          },
                        })
                      : column.isImage
                      ? CellMaker.makeImage({
                          click: (e, ctx) => {
                            column.clickEvent(e, ctx);
                          },
                        })
                      : column.isLink
                      ? CellMaker.makeLink({
                          click: (e, ctx) => {
                            column.clickEvent(e, ctx);
                          },
                        })
                      : null
                  }
                  editor={
                    column.dataType?.inputColor
                      ? new InputColor(document.createElement("div"))
                      : column.dataType == "Date" && column.isTime
                      ? new InputTime(document.createElement("div"), {
                          format: column.format,
                          step: column.timeStep,
                        })
                      : column.dataType == "Date"
                      ? new InputDate(document.createElement("div"))
                      : column.dataMap
                      ? !(column.dataMapEditor === "RadioButtons")
                        ? new AutoComplete(document.createElement("div"), {
                            itemsSource: column.dataMap,
                            selectedValuePath: column.dataMapCode,
                            displayMemberPath: column.dataMapValue,
                          })
                        : null
                      : null
                  }
                  aggregate={column.aggregate} // footer에 합 출력
                />
              );
            })}
        </FlexSheet>
        <div ref={this.useRefEditDiv} style={{ display: "none" }}>
          <E3Button
            label={"스타일 저장"}
            onClick={() => {
              this.saveSheetStyle();
            }}
          />
          <div>
            폰트 &nbsp;&nbsp;&nbsp;
            <ComboBox
              style={{ width: 120 }}
              itemsSource={this.fonts}
              displayMemberPath={"name"}
              selectedValuePath={"value"}
              selectedIndexChanged={this.fontChanged}
            />
            <ComboBox
              style={{ width: 80 }}
              itemsSource={this.fontSizeList}
              displayMemberPath={"name"}
              selectedValuePath={"value"}
              selectedIndexChanged={this.fontSizeChanged}
            />
            <E3Button
              label={"Bold"}
              onClick={() => {
                this.applyBoldStyle();
              }}
            />
            <E3Button
              label={"Italic"}
              onClick={() => {
                this.applyItalicStyle();
              }}
            />
            <E3Button
              label={"Underline"}
              onClick={() => {
                this.applyUnderlineStyle();
              }}
            />
          </div>
          <div>
            색상 &nbsp;&nbsp;&nbsp;
            <ColorPicker
              ref={this.useRefColorPicker}
              style={{ display: "none", position: "fixed", zIndex: 100 }}
              initialized={this.colorPickerInit.bind(this)}
            />
            <E3Button
              label={"Fore Color"}
              onClick={() => {
                this.showColorPicker(false);
              }}
            />
            <E3Button
              label={"Fill Color"}
              onClick={() => {
                this.showColorPicker(true);
              }}
            />
          </div>
          <div>
            좌우 정렬 &nbsp;&nbsp;&nbsp;
            <E3Button
              label={"Left"}
              onClick={() => {
                this.applyCellTextAlign("left");
              }}
            />
            <E3Button
              label={"Center"}
              onClick={() => {
                this.applyCellTextAlign("center");
              }}
            />
            <E3Button
              label={"Right"}
              onClick={() => {
                this.applyCellTextAlign("right");
              }}
            />
          </div>
          <div>
            상하 정렬 &nbsp;&nbsp;&nbsp;
            <E3Button
              label={"Top"}
              onClick={() => {
                this.applyCellTextVerticalAlign("start");
              }}
            />
            <E3Button
              label={"Middle"}
              onClick={() => {
                this.applyCellTextVerticalAlign("center");
              }}
            />
            <E3Button
              label={"Bottom"}
              onClick={() => {
                this.applyCellTextVerticalAlign("end");
              }}
            />
          </div>
          <div>
            행/열 읽기전용 적용/해제 &nbsp;&nbsp;&nbsp;
            <E3Button
              label={"적용"}
              onClick={() => {
                this.applyCellEditStyle("readOnly", true);
              }}
            />
            <E3Button
              label={"해제"}
              onClick={() => {
                this.applyCellEditStyle("readOnly", false);
              }}
            />
            {this.state.cellEditStyle
              .filter(
                (element) =>
                  element.sheetIdx === this.refGrid.current.sheets.selectedIndex && element.type === "readOnly"
              )
              .map((element, index, array) => (
                <E3Button
                  key={String(element.sheetIdx) + `_` + String(element.type) + `_` + String(element.value)}
                  label={String(element.value)}
                  onClick={() => {
                    this.applyCellEditStyle("readOnly", false, element.value);
                  }}
                />
              ))}
          </div>
          <div>
            셀 내용 고정 영역 &nbsp;&nbsp;&nbsp;
            <E3Button
              label={"적용"}
              onClick={() => {
                this.applyCellEditStyle("fixArea", true);
              }}
            />
            <E3Button
              label={"해제"}
              onClick={() => {
                this.applyCellEditStyle("fixArea", false);
              }}
            />
            {this.state.cellEditStyle
              .filter(
                (element) =>
                  element.sheetIdx === this.refGrid.current.sheets.selectedIndex && element.type === "fixArea"
              )
              .map((element, index, array) => (
                <E3Button
                  key={String(element.sheetIdx) + `_` + String(element.type) + `_` + String(element.value)}
                  label={String(element.value)}
                  onClick={() => {
                    this.applyCellEditStyle("fixArea", false, element.value);
                  }}
                />
              ))}
          </div>
          <div>
            편집 &nbsp;&nbsp;&nbsp;
            <E3Button
              label={"셀 머지"}
              onClick={() => {
                this.setMergeRange();
              }}
            />
            <label className={styles.label} htmlFor={this.props.gridId + "customCellMerge"}>
              <input
                className={styles.checkbox}
                type={"checkbox"}
                id={this.props.gridId + "customCellMerge"}
                name={"커스텀 머지"}
                onChange={this.applyCustomCellMerge}
                checked={
                  this.state.cellEditStyle.filter(
                    (element) =>
                      element.sheetIdx === this.refGrid.current.sheets.selectedIndex &&
                      element.type === "customMergeYn" &&
                      element.value === "Y"
                  ).length > 0
                    ? true
                    : false
                }
              />
              <p className={styles.labelText}>커스텀 셀 머지 (셀 내용이 같으면 자동으로 머지)</p>
            </label>
          </div>
          <div>
            행/열 고정 &nbsp;&nbsp;&nbsp;
            <E3Button
              label={"적용"}
              onClick={() => {
                this.applyCellEditStyle("frozenCell", true);
              }}
            />
            <E3Button
              label={"해제"}
              onClick={() => {
                this.applyCellEditStyle("frozenCell", false);
              }}
            />
            {this.state.cellEditStyle
              .filter(
                (element) =>
                  element.sheetIdx === this.refGrid.current.sheets.selectedIndex && element.type === "frozenCell"
              )
              .map((element, index, array) => (
                <E3Button
                  key={String(element.sheetIdx) + `_` + String(element.type) + `_` + String(element.value)}
                  label={String(element.value)}
                  onClick={() => {
                    this.applyCellEditStyle("frozenCell", false, element.value);
                  }}
                />
              ))}
          </div>
        </div>
        {this.state.exportExcel ? (
          <button onClick={this.saveExcel} className="btn btn-default">
            Export
          </button>
        ) : null}
        <input
          ref={this.useRefInput}
          className="input-excel-import"
          style={{ display: "none" }}
          type="file"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          onChange={(e) => {
            // loadExcel은 문제가 있어서 loadExcelMakeGridData를 사용함
            // this.loadExcelMakeGridData(e.target.files[0], false, true);
            this.loadExcelMakeGridData(e.target.files[0]);
          }}
        />
      </div>
    );
  }

  /**
   * FlexSheet 관련 함수
   *
   * init
   */

  // 그리드 첫 렌더링 시 동작
  flexInitialized(FlexSheet) {
    this.refGrid.current = FlexSheet;

    /* make drag column */
    if (this.props.isDragColumn) {
      FlexSheet.allowDragging = wjGrid.AllowDragging.Both;

      for (let i = 0; i < 1; i++) {
        FlexSheet.rowHeaders.columns.insert(0, new wjGrid.Column());
      }
    }

    // FlexGridSearch exc
    if (this.props.isSearchFilter) {
      this.props.isSearchFilter.current.control.grid = FlexSheet;
      // 특정 컬럼(ROW_CHECK, ROW_STATUS)은 필터에서 제외함
      var exceptColumns = ["ROW_CHECK", "ROW_STATUS"];
      this.props.isSearchFilter.current.control._getItemText = function (e) {
        for (var t = [], r = this._g._getBindingColumns(), i = 0; i < r.length; i++) {
          var n = r[i],
            o = n._binding;
          if (exceptColumns.includes(n.binding)) continue;
          if (o && (n.visible || this.searchAllColumns)) {
            var a = o.getValue(e);
            a = n.dataMap ? n.dataMap.getDisplayValue(a) : Globalize.format(a, n.format);
            n.isContentHtml && (a = toPlainText(a));
            a && t.push(a);
          }
        }
        return t.join(" ");
      };
    }

    if (!this.state.defaultColumn) {
      FlexSheet.rowHeaders.columns.splice(0, 1);
    }

    FlexSheet.formatItem.addHandler((s, e) => {
      if (e.panel.cellType == CellType.ColumnHeader) {
        // Grid Header MultiLine 적용
        this.headerMultiLine(e);

        // Grid Header Style 적용
        this.addHeaderStyle(e);
      } else if (e.panel == s.cells) {
        if (this.state.onCellUpdate) this.state.onCellUpdate(s, e);

        // 생성된 CellMaker 선택적 제거 (multi header는 현재 기능 존재 x)
        if (this.state.columns.length) {
          this.removeCellMaker(s, e);
        }
      }
    });

    /* drag function */
    FlexSheet.draggedRow.addHandler((s, e) => {
      const startRow = e.data.row;
      const endRow = e.row;

      if (endRow > startRow) {
        for (let i = startRow; i <= endRow; i++) {
          let rowTmp = s.rows[i]?.dataItem;
          rowTmp.ROW_STATUS = 2;
          rowTmp.ROW_CHECK = true;
        }
      } else {
        for (let i = endRow; i <= startRow; i++) {
          let rowTmp = s.rows[i]?.dataItem;
          rowTmp.ROW_STATUS = 2;
          rowTmp.ROW_CHECK = true;
        }
      }
    });
    /* drag function */

    FlexSheet.cellEditEnding.addHandler((s, e) => {
      // 수정 Flag 부여
      var row = s.rows[e.row]?.dataItem;
      if (row && row.ROW_STATUS == "") {
        row.ROW_STATUS = 2;
        row.ROW_CHECK = true;
      }

      // 주요값
      var colId = e._p._cols[e.col].binding;
      var colName = e._p._cols[e.col]._hdr;
      var value = s.activeEditor?.value;

      // validateInfo가 없으면 유효성 체크를 하지 않음
      if (!this.state.validateInfo) {
        return;
      }
      // validateInfo에 colId 존재여부 확인. 없으면 건너뜀
      else if (!this.state.validateInfo.hasOwnProperty(colId)) {
        return;
      }

      var validInfo = this.state.validateInfo[colId];

      // yml 파일의 컬럼 ID와 현재 셀의 컬럼 ID가 동일하면 validation 수행
      if (validInfo) {
        // validate() 수행 시 error를 throw하므로 try catch를 사용하여 alert창 띄움
        try {
          validate(getValidateObject(validInfo, colName, value));
        } catch (ex) {
          e.cancel = true;
          e.stayInEditMode = true;
          alert(ex);
        }
      }

      if (this.state.onCellEditEnding) this.state.onCellEditEnding(s, e);
    });

    FlexSheet.cellEditEnded.addHandler((s, e) => {
      if (this.state.onCellEditEnded) this.state.onCellEditEnded(s, e);
    });

    FlexSheet.rowAdded.addHandler((s, e) => {
      if (this.state.onRowAdded) this.state.onRowAdded(s, e);
    });

    FlexSheet.deletingRow.addHandler((s, e) => {
      if (this.state.onDeletingRow) this.state.onDeletingRow(s, e);
    });

    FlexSheet.beginningEdit.addHandler((s, e) => {
      // 컨트롤이 달력인 경우 width 값을 설정함
      if (e.panel.columns[e.col].editor?.calendar > "") {
        e.panel.columns[e.col].editor.dropDown.style.width = "".concat(300, "px");
      }
      if (this.state.beginningEdit) this.state.beginningEdit(s, e);
    });

    FlexSheet.sortedColumn.addHandler((s, e) => {
      if (this.state.sortedColumn) this.state.sortedColumn(s, e);
    });

    FlexSheet.loadedRows.addHandler((s, e) => {
      if (this.state.onloadedRows) this.state.onloadedRows(s, e);
    });

    FlexSheet.formatItem.addHandler((s, e) => {
      if (this.state.onFormatItem) this.state.onFormatItem(s, e);
    });

    // 시트용 이벤트 추가
    FlexSheet.selectedSheetChanged.addHandler((s, e) => {
      this.setState(
        (prev) => ({
          cellEditStyle: [...prev.cellEditStyle],
        }),
        () => {
          // 커스텀 머지 여부를 확인
          const temp = this.state.cellEditStyle.filter(
            (item) => item.type === "customMergeYn" && item.sheetIdx === e.newValue && item.value === "Y"
          );
          if (temp.length > 0) this.setCustomMergeManager(s[e.newValue]);
          else this.setDefaultMergeManager(s[e.newValue]);
        }
      );

      if (this.state.onSelectedSheetChanged) this.state.onSelectedSheetChanged(s, e);
    });

    // 시트 context 메뉴 중 컬럼 관련된 항목은 숨김처리
    FlexSheet._contextMenu._insCols.hidden = true;
    FlexSheet._contextMenu._delCols.hidden = true;

    // 시트셀에서 편집시 첫 글자가 무조건 영문으로 인식되는 현상 수정
    FlexSheet.imeEnabled = true;

    // 마우스 클릭 이벤트 추가
    FlexSheet.addEventListener(FlexSheet.hostElement, "click", (e) => {
      let ht = FlexSheet.hitTest(e);
      if (CellType[ht.cellType] == "ColumnHeader" || ht.row < 0) return;
      this.clicks++;
      if (this.clicks === 1) {
        setTimeout(() => {
          if (this.clicks === 1 && this.state.onRowClick) {
            this.state.onRowClick();
            // 더블클릭 시, 에디터 모드가 아닌 경우에만 이벤트 추가
          } else if (this.clicks > 1 && ht._target.ariaReadOnly && this.state.onRowDoubleClick) {
            this.state.onRowDoubleClick();
          }

          this.clicks = 0;
        }, 300);
      }
    });

    //그리드 헤더에 체크박스 추가
    if (this.props.isAllCheckbox) {
      let chkBoxColumn = this.props.checkBoxColumn;
      FlexSheet.itemFormatter = function (panel, r, c, cell) {
        if (CellType[panel.cellType] == "ColumnHeader") {
          var flex = panel.grid;
          var col = flex.columns[c];

          if (col.binding == chkBoxColumn) {
            col.allowSorting = false;

            var cnt = 0;
            for (var i = 0; i < flex.rows.length; i++) {
              if (flex.getCellData(i, c) == true) cnt++;
            }

            cell.innerHTML = '<input type="checkbox"> '; // + cell.innerHTML;
            var cb = cell.firstChild;
            cb.checked = cnt > 0;
            cb.indeterminate = cnt > 0 && cnt < flex.rows.length;

            cb.addEventListener("click", function (e) {
              flex.beginUpdate();
              for (var i = 0; i < flex.rows.length; i++) {
                flex.setCellData(i, c, cb.checked);
              }
              flex.endUpdate();
            });
          }
        }
      };
    }

    if (this.props.gridId) {
      this.setState({ gridId: this.props.gridId });
    }

    // 그리드 개인화 정보가 존재하면 적용
    var menuId = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_ID);
    var gridPsn = getLocalStorageItem(LOCAL_STORAGE_KEYS.GRID_PSN);
    if (gridPsn > "") {
      var gridPsnFilter = JSON.parse(gridPsn).filter((row) => {
        return row.menuId === menuId && row.gridId === this.props.gridId;
      });
      if (gridPsnFilter.length == 1) {
        this.setColumns(JSON.parse(gridPsnFilter[0].columnInfo));
        var frozenColumns = gridPsnFilter[0].frozenColumns;
        this.refGrid.current.frozenColumns = frozenColumns > 0 ? frozenColumns : 0;
      }
    }

    // 시트 스타일 정보가 존재하면적용
    const sheetStyle = JSON.parse(getLocalStorageItem(LOCAL_STORAGE_KEYS.SHEET_STYLE));
    if (sheetStyle > "") {
      // 메뉴 및 그리드ID 매칭
      const filterSheetStyle = sheetStyle.filter((row) => {
        return row.MENU_ID === menuId && row.GRID_ID === this.props.gridId;
      });
      // 데이터가 존재하면 시트 스타일 정보 적용
      if (filterSheetStyle.length > 0) {
        for (let i = 0; i < filterSheetStyle.length; i++) {
          // 시트 추가
          const defaultSheet = this.refGrid.current.sheets.filter((sheet) => sheet.name === "defaultSheet");
          const curSheet = _.cloneDeep(defaultSheet[0]);
          defaultSheet[0].visible = false;
          curSheet.visible = true;
          curSheet.name = filterSheetStyle[i].SHEET_NM;
          curSheet._ownerHeaderRowRemoved = true; // 컬럼 ID는 제거
          const sheetUuid = filterSheetStyle[i].SHEET_UUID;
          curSheet._uuid = sheetUuid ? sheetUuid : uuid();
          this.refGrid.current.sheets.push(curSheet);

          // SHEET_IDX 에 해당하는 시트 활성화
          const sheetIdx = Number(filterSheetStyle[i].SHEET_IDX);
          this.findSelectedSheet(sheetIdx);
          const sheet = this.refGrid.current.selectedSheet;

          // 스타일 적용
          const cellStyle = JSON.parse(filterSheetStyle[i].CELL_STYLE);
          sheet.columnCount = cellStyle.columnCount;
          for (let cell in cellStyle) {
            if (isNaN(cell)) continue;
            let row = Math.floor(cell / cellStyle.columnCount);
            let col = cell % cellStyle.columnCount;
            sheet._flex.applyCellsStyle(cellStyle[cell], [new CellRange(row, col, row, col)]);
          }

          // 머지 적용
          const mergeRange = JSON.parse(filterSheetStyle[i].MERGE_RANGE);
          const mergeRangeLength = mergeRange.length;
          for (let i = 0; i < mergeRangeLength; i++) {
            this.setMergeRange(mergeRange[i]);
          }

          // 읽기 전용 적용
          const readOnly = JSON.parse(filterSheetStyle[i].READ_ONLY);
          for (let item in readOnly) {
            this.applyCellEditStyle("readOnly", true, readOnly[item]);
          }

          // 고정 영역 적용
          const fixArea = JSON.parse(filterSheetStyle[i].FIX_AREA);
          for (let items in fixArea) {
            this.applyCellEditStyle("fixArea", true, fixArea[items][0].range);
            for (let item in fixArea[items]) {
              const temp = fixArea[items][item];
              sheet._flex.setCellData(temp.row, temp.col, temp.value);
              //sheet.itemsSource.items[temp.row][temp.colId] = temp.value; // 데이터 바인딩 이후에 사용가능
            }
          }

          // 커스텀 머지 적용
          const customMergeYn = filterSheetStyle[i].CUSTOM_MERGE_YN;
          if (customMergeYn === "Y") {
            this.setCustomMergeManager(sheet);
            this.setState((prev) => ({
              cellEditStyle: [...prev.cellEditStyle, { sheetIdx: sheetIdx, type: "customMergeYn", value: "Y" }],
            }));
          } else {
            this.setDefaultMergeManager(sheet);
          }

          // 셀 고정 적용
          const frozenCell = JSON.parse(filterSheetStyle[i].FROZEN_CELL);
          for (let item in frozenCell) {
            this.applyCellEditStyle("frozenCell", true, frozenCell[item]);
          }
        }

        this.refresh();
      }
    }

    // 그리드 footer 사용여부
    if (this.props.isColumnFooters) {
      FlexSheet.columnFooters.rows.push(new wjGrid.GroupRow());
      if (this.props.columnFooterName) {
        const idx = this.props.columnFooterName.idx ?? 0;
        const name = this.props.columnFooterName.name ?? "합계";
        this.refGrid.current.columnFooters.setCellData(0, idx, name);
      }
    }

    this.refGrid.current = FlexSheet;
    //this.setState({ grid: FlexSheet });
  }

  // 콤보박스 첫 렌더링 시 동작
  initCombo(comboBox) {
    this.setState({ combo: comboBox });
  }

  // 콤보박스 text 처리
  onTextChanged() {
    if (this.refGrid.current) {
      let mode = asEnum(this.state.combo.selectedIndex, SelectionMode);
      this.refGrid.current.selectionMode = mode;

      this.setState({
        selectionMode: mode,
      });
    }
  }

  setDataBinding = (datasource, sheetName, columns, callback) => {
    if (!datasource) return;

    // 그리드의 flexInitialized 이벤트가 완료 되지 않은 채 setDataBinding 실행이 되어서 약간의 딜레이를 줌 (화면을 열고난 뒤, 바로 조회하는 화면)
    const timer = setTimeout(() => {
      if (this.refGrid.current) {
        clearTimeout(timer);
        this.setDataBinding2(datasource, sheetName, columns, callback);
      }
    }, 300);
  };

  setDataBinding2 = (datasource, sheetName, columns, callback) => {
    // Tree 그리드 데이터 중복 제거
    if (this.props.childItemsPath > "") {
      var dupArray = [];
      var cnt = datasource.length;
      for (var i = 0; i < cnt; i++) {
        // CHILDREN_ID 에서 MENU_ID를 가져온다
        // 해당 MENU_ID를 datasource에서 찾아서 가져온다. (datasource에서는 제거)
        // 가져온 row를 CHILDREN_ID의 배열에 넣는다.
        var children = datasource[i].CHILDREN_ID ? datasource[i].CHILDREN_ID.split(",") : "";
        if (children > "") {
          var childrenArray = [];
          for (var j = 0; j < children.length; j++) {
            var obj = datasource.filter((row) => row.MENU_ID == children[j]);
            if (obj.length > 0) childrenArray.push(obj[0]);
          }
          datasource[i].CHILDREN_ID = childrenArray;
          dupArray = [...dupArray, ...childrenArray];
        }
      }
      // 중복제거
      dupArray = dupArray.reduce((acc, cur, idx, src) => (acc.includes(cur) ? acc : [...acc, cur]), []);
      // datasource에서 dupArray에 있는 MENU_ID 제거 (이미 CHILDREN_ID에 존재하기 때문)
      dupArray.forEach((f) =>
        datasource.splice(
          datasource.findIndex((e) => e.MENU_ID === f.MENU_ID),
          1
        )
      );
      // isCollapseGroupsToLevel0값이 true이면 초기 조회시 묶어서 출력함
      if (this.props.isCollapseGroupsToLevel0) callback = () => this.refGrid.current.collapseGroupsToLevel(0);
    }

    let bindingData = "";

    if (typeof datasource === "string") {
      bindingData = JSON.parse(datasource);
    } else {
      bindingData = datasource;
    }

    if (this.state.columns.find((c) => c.binding == this.props.checkBoxColumn)) {
      bindingData.map((e, idx) => {
        //console.log(e, this.props.checkBoxColumn, e[this.props.checkBoxColumn])
        if (e[this.props.checkBoxColumn]?.length > 0) {
          if (
            e[this.props.checkBoxColumn].toLowerCase() == "true" ||
            e[this.props.checkBoxColumn].toLowerCase() == "1"
          ) {
            bindingData[idx][this.props.checkBoxColumn] = 1;
          } else if (
            e[this.props.checkBoxColumn].toLowerCase() == "false" ||
            e[this.props.checkBoxColumn].toLowerCase() == "0"
          ) {
            bindingData[idx][this.props.checkBoxColumn] = 0;
          }
        }
      });
    }

    // if (this.props.isNo) {
    //   bindingData = bindingData.map((data, idx) => {
    //     return { NO: ++idx, ...data };
    //   });
    // }

    if (this.props.validateYmlFile) {
      getObjectFromYml(this.props.validateYmlFile).then((res) => {
        this.setState({ validateInfo: res });
      });
    }

    let formatList = this.state.columns.filter((e) => e.dataType);

    if (this.chkArray(formatList)) {
      formatList.map((format) => {
        let filterList = bindingData.filter((e) => Object.keys(e).includes(format.binding));

        if (this.chkArray(filterList)) {
          this.makeDataType(filterList, format);
        }
      });
    }

    // 고정영역이 존재한다면, TEXT를 bindingData에 바인딩 함
    if (!sheetName) sheetName = uuid();
    const sheetStyle = getLocalStorageItem(LOCAL_STORAGE_KEYS.SHEET_STYLE)
      ? JSON.parse(getLocalStorageItem(LOCAL_STORAGE_KEYS.SHEET_STYLE))
      : [];
    const menuId = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_ID);
    const filterSheetStyle = sheetStyle.filter((row) => {
      return (
        row.MENU_ID === menuId &&
        row.GRID_ID === this.props.gridId &&
        (row.SHEET_UUID === sheetName || row.SHEET_NM === sheetName)
      );
    });
    // 데이터가 존재하면 시트 스타일 정보 적용
    if (filterSheetStyle.length > 0) {
      const fixArea = JSON.parse(filterSheetStyle[0].FIX_AREA);
      for (let items in fixArea) {
        for (let item in fixArea[items]) {
          const temp = fixArea[items][item];
          bindingData[temp.row][temp.colId] = temp.value;
        }
      }
    }

    this.setState(
      {
        source: bindingData,
        [sheetName]: new CollectionView(bindingData, {
          sortDescriptions: this.state.sortDescriptions,
          groupDescriptions: this.state.groupDescriptions,
          trackChanges: this.state.trackChanges,
        }),
      },
      () => {
        // Tree 그리드 인 경우 행의 readonly 값 변경 (기본이 true)
        if (this.props.childItemsPath > "") {
          this.refGrid.current.rows.forEach((row) => {
            row.isReadOnly = false;
          });
        }

        // 해당 시트에 데이터바인딩
        let curSheet = this.refGrid.current.sheets.filter(
          (sheet) => sheet._uuid === sheetName || sheet.name === sheetName
        );
        if (curSheet.length > 0) {
          curSheet = curSheet[0];
          curSheet.itemsSource = this.state[sheetName];
        }
        // 시트명이 없으면 새로운 시트 생성
        else {
          let defaultSheet = this.refGrid.current.sheets.filter((sheet) => sheet.name === "defaultSheet");
          curSheet = _.cloneDeep(defaultSheet[0]);
          defaultSheet[0].visible = false;
          curSheet.visible = true;
          curSheet.name = sheetName;
          curSheet._uuid = uuid();
          curSheet.itemsSource = this.state[sheetName];
          this.refGrid.current.sheets.push(curSheet);
        }

        // 컬럼 속성 바인딩
        for (let col in columns) {
          for (let item in columns[col]) {
            curSheet._flex.columns[col][item] = columns[col][item];
          }
        }

        if (callback > "") callback(this);
      }
    );
  };

  // ### 시트 추가 로직 : 여기부터

  // 시트 편집 기능 영역 보여주기/말기
  setEditDivVisible(value) {
    let display = this.useRefEditDiv.current.style.display;
    if (typeof value == "undefined" || value == null || value == "") {
      if (display === "block") display = "none";
      else display = "block";
    } else if (value) display = "block";
    else display = "none";

    this.useRefEditDiv.current.style.display = display;
  }

  // 기본 머지 매니저
  setDefaultMergeManager(sheet) {
    const temp = sheet ? sheet : this.refGrid.current.selectedSheet;
    temp._flex.mergeManager = new wjGrid.MergeManager();
  }

  // 커스텀 된 머지 매니저
  // 기본적으로는 같은 셀이 합쳐지나, 앞의 셀 값이 뒤에 셀 머지에 영향을 추도록 함. (앞의 셀 값이 같아야 현재 셀이 머지됨)
  // 컬럼 머지 지원
  setCustomMergeManager(sheet) {
    const temp = sheet ? sheet : this.refGrid.current.selectedSheet;
    temp._flex.mergeManager = new RestrictedMergeManager();
  }

  // 셀 머지 및 스타일 적용 후 refresh해야 ui쪽 업데이트가 됨
  refresh() {
    this.refGrid.current.refresh();
  }

  // 특정 시트틑 활성화 함
  // 시트가 활성화 되지 않은 상태에서 접근하면 sheet 전용 속성을 사용할 수 없음
  findSelectedSheet(idx) {
    if (idx === 1) {
      this.refGrid.current.sheets.selectFirst();
      return;
    } else if (this.refGrid.current.selectedSheetIndex < idx) {
      this.refGrid.current.sheets.selectNext();
      return this.findSelectedSheet(idx);
    } else return;
  }

  // 셀 머지
  setMergeRange(cellRange) {
    const curSheet = this.refGrid.current.selectedSheet;
    if (cellRange) {
      curSheet._flex.mergeRange(new CellRange(cellRange._row, cellRange._col, cellRange._row2, cellRange._col2));
    } else {
      curSheet._flex.mergeRange();
    }
    this.refresh();
  }

  // 스타일 저장
  saveSheetStyle() {
    const menuId = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_ID);
    const gridId = this.props.gridId;
    const sheetLength = this.refGrid.current.sheets.length;
    let params = [];
    for (let i = 1; i < sheetLength; i++) {
      this.findSelectedSheet(i);
      const ref = this.refGrid.current;
      const sheet = ref.selectedSheet;
      const sheetNm = sheet.name;
      const readonly = this.state.cellEditStyle
        .filter((item) => item.sheetIdx === i && item.type === "readOnly")
        .map((item) => item.value);
      const fixArea = this.state.cellEditStyle
        .filter((item) => item.sheetIdx === i && item.type === "fixArea")
        .map((item) => {
          const range = item.value;
          // 열
          if (isNaN(range)) {
            const col = this.colToNum(range);
            const colId = ref.columns[col].binding;
            return ref.rows
              .filter((item) => item.dataItem)
              .map((item) => {
                return {
                  range: range,
                  row: item.dataIndex,
                  col: col,
                  colId: colId,
                  value: item.dataItem[colId],
                };
              });
          }
          // 행
          else {
            const idx = Number(range) - 1;
            return Object.entries(ref.rows[idx].dataItem)
              .map(([col, value]) => {
                return { colId: col, value: value };
              })
              .map((item) => {
                const col = sheet._flex.columns.filter((e) => e.binding === item.colId);

                return { range: range, row: idx, col: col[0].index, ...item };
              });
          }
        });
      const customMergeYn =
        this.state.cellEditStyle.filter(
          (item) => item.type === "customMergeYn" && item.sheetIdx === i && item.value === "Y"
        ).length > 0
          ? "Y"
          : "N";
      const sheetUuid = isNaN(sheet._uuid) ? sheet._uuid : uuid();
      const frozenCell = this.state.cellEditStyle
        .filter((item) => item.sheetIdx === i && item.type === "frozenCell")
        .map((item) => item.value);

      params.push({
        MENU_ID: menuId,
        GRID_ID: gridId,
        SHEET_IDX: i,
        SHEET_NM: sheetNm,
        CELL_STYLE: JSON.stringify(sheet._styledCells),
        MERGE_RANGE: JSON.stringify(sheet._mergedRanges),
        READ_ONLY: JSON.stringify(readonly),
        FIX_AREA: JSON.stringify(fixArea),
        CUSTOM_MERGE_YN: customMergeYn,
        SHEET_UUID: sheetUuid,
        FROZEN_CELL: JSON.stringify(frozenCell),
      });
    }

    const sheetStyle = JSON.parse(getLocalStorageItem(LOCAL_STORAGE_KEYS.SHEET_STYLE));
    const filterSheetStyle = sheetStyle.filter((row) => !(row.MENU_ID === menuId && row.GRID_ID === gridId));
    const newSheetStyle = [...filterSheetStyle, ...params];

    // 로컬 스토리지 저장
    setLocalStorageItem(LOCAL_STORAGE_KEYS.SHEET_STYLE, JSON.stringify(newSheetStyle));

    const rtnObj = {
      // url: `/demo/saveSheetStyle`,
      url: `/E3/SYSTEM/SaveSheetStyle`,
      option1: { method: "POST", body: params },
      option2: { showConfirm: false },
    };

    this.state.onSaveStyle(rtnObj);

    return {
      // url: `/demo/saveSheetStyle`,
      url: `/E3/SYSTEM/SaveSheetStyle`,
      option1: { method: "POST", body: params },
      option2: { showConfirm: false },
    };
  }

  // 변경가능한 폰트 목록
  fonts = [
    { name: "맑은고딕", value: "Malgun Gothic" },
    // { name: 'Arial', value: 'Arial, Helvetica, sans-serif' },
    // { name: 'Arial Black', value: '"Arial Black", Gadget, sans-serif' },
    // { name: 'Comic Sans MS', value: '"Comic Sans MS", cursive, sans-serif' },
    // { name: 'Courier New', value: '"Courier New", Courier, monospace' },
    // { name: 'Georgia', value: 'Georgia, serif' },
    // { name: 'Impact', value: 'Impact, Charcoal, sans-serif' },
    // { name: 'Lucida Console', value: '"Lucida Console", Monaco, monospace' },
    // { name: 'Lucida Sans Unicode', value: '"Lucida Sans Unicode", "Lucida Grande", sans-serif' },
    // { name: 'Palatino Linotype', value: '"Palatino Linotype", "Book Antiqua", Palatino, serif' },
    // { name: 'Tahoma', value: 'Tahoma, Geneva, sans-serif' },
    // { name: 'Segoe UI', value: '"Segoe UI", "Roboto", sans-serif' },
    // { name: 'Times New Roman', value: '"Times New Roman", Times, serif' },
    // { name: 'Trebuchet MS', value: '"Trebuchet MS", Helvetica, sans-serif' },
    // { name: 'Verdana', value: 'Verdana, Geneva, sans-serif' }
  ];
  // 변경가능한 폰트 크기
  fontSizeList = [
    { name: "8", value: "8px" },
    { name: "9", value: "9px" },
    { name: "10", value: "10px" },
    { name: "11", value: "11px" },
    { name: "12", value: "12px" },
    { name: "13", value: "13px" },
    { name: "14", value: "14px" },
    { name: "16", value: "16px" },
    { name: "18", value: "18px" },
    { name: "20", value: "20px" },
    { name: "22", value: "22px" },
    { name: "24", value: "24px" },
  ];
  // 시트 스타일 편집 : 폰트 변경시
  fontChanged = (sender) => {
    this.refGrid.current.applyCellsStyle({
      fontFamily: sender.selectedItem.value,
    });
  };
  // 시트 스타일 편집 : 폰트 크기 변경시
  fontSizeChanged = (sender) => {
    this.refGrid.current.applyCellsStyle({
      fontSize: sender.selectedItem.value,
    });
  };
  // 시트 스타일 편집 : 폰트 스타일 변경시
  getSelectedCellStyle = (ref) => {
    const row = ref.selectedRanges[0].row;
    const col = ref.selectedRanges[0].col;
    const colCnt = ref.columns.length;
    return ref.selectedSheet._styledCells[row * colCnt + col];
  };
  applyBoldStyle = () => {
    const ref = this.refGrid.current;
    if (this.getSelectedCellStyle(ref)?.fontWeight === "bold") {
      ref.applyCellsStyle({ fontWeight: "none" });
    } else {
      ref.applyCellsStyle({ fontWeight: "bold" });
    }
  };
  applyUnderlineStyle = () => {
    const ref = this.refGrid.current;
    if (this.getSelectedCellStyle(ref)?.textDecoration === "underline") {
      ref.applyCellsStyle({ textDecoration: "none" });
    } else {
      ref.applyCellsStyle({ textDecoration: "underline" });
    }
  };
  applyItalicStyle = () => {
    const ref = this.refGrid.current;
    if (this.getSelectedCellStyle(ref)?.fontStyle === "italic") {
      ref.applyCellsStyle({ fontStyle: "none" });
    } else {
      ref.applyCellsStyle({ fontStyle: "italic" });
    }
  };
  // 시트 스타일 편집 : 셀 색상 변경시
  colorPickerInit = (sender) => {
    this.useRefColorPicker.current = sender;
    // if the browser is firefox, we should bind the blur event. (TFS #124387)
    // if the browser is IE, we should bind the focusout event. (TFS #124500)
    let blurEvt = /firefox/i.test(window.navigator.userAgent) ? "blur" : "focusout";
    // Hide the color picker control when it lost the focus.
    sender.hostElement.addEventListener(blurEvt, () => {
      setTimeout(() => {
        if (!sender.containsFocus()) {
          this.useRefUpdatingSelection.current = false;
          sender.hostElement.style.display = "none";
          this.useRefColorPicker.current = sender;
        }
      }, 0);
    });
    //
    // Initialize the value changed event handler for the color picker control.
    sender.valueChanged.addHandler(() => {
      var _a, _b;
      if (this.useRefApplyFillColor.current) {
        (_a = this.refGrid.current) === null || _a === void 0
          ? void 0
          : _a.applyCellsStyle({ backgroundColor: sender.value });
      } else {
        (_b = this.refGrid.current) === null || _b === void 0 ? void 0 : _b.applyCellsStyle({ color: sender.value });
      }

      this.useRefColorPicker.current = sender;
    });
  };
  showColorPicker = (isFillColor) => {
    this.useRefColorPicker.current.hostElement.style.display = "inline";
    //this.useRefColorPicker.current.style.left = offset.left + 'px';
    //this.useRefColorPicker.current.style.top = offset.top - he.clientHeight - 5 + 'px';
    this.useRefColorPicker.current.focus();
    this.useRefApplyFillColor.current = isFillColor;
  };
  // 시트 스타일 편집 : 셀 정렬 변경 시
  applyCellTextAlign = (value) => {
    this.refGrid.current.applyCellsStyle({ textAlign: value });
  };
  applyCellTextVerticalAlign = (value) => {
    this.refGrid.current.applyCellsStyle({ display: "inline-grid" });
    this.refGrid.current.applyCellsStyle({ alignItems: value });
  };
  // 시트 스타일 편집 : 자동 셀 머지 여부
  applyCustomCellMerge = (e) => {
    const idx = this.refGrid.current.sheets.selectedIndex;
    const type = "customMergeYn";
    const value = e.target.checked;
    const temp = this.state.cellEditStyle.filter(
      (item) => item.sheetIdx === idx && item.type === type && item.value === "Y"
    );
    if (value && temp.length > 0) {
      return;
    } else if (value) {
      this.setState((prev) => ({
        cellEditStyle: [...prev.cellEditStyle, { sheetIdx: idx, type: type, value: "Y" }],
      }));
      this.setCustomMergeManager();
    } else {
      this.setState((prev) => ({
        cellEditStyle: this.state.cellEditStyle.filter(
          (item) => item.value !== "Y" && item.sheetIdx === idx && item.type === type
        ),
      }));
      this.setDefaultMergeManager();
    }
  };
  // 엑셀 열 이름을 숫자로 매핑하는 함수
  colToNum = (col) => {
    if (!isNaN(col)) return col;
    let num = 0;
    for (let i = 0; i < col.length; i++) {
      num = num * 26 + (col.charCodeAt(i) - "A".charCodeAt(0) + 1);
    }
    return num - 1;
  };
  // 숫자를 엑셀 열 이름으로 매핑하는 함수
  numToCol = (num) => {
    // 12345678901234567890123456
    // ABCDEFGHIJKLMNOPQRSTUVWXYZ
    num++;
    let col = "";
    while (num > 0) {
      let remainder = num % 26;
      if (remainder === 0) {
        col = "Z" + col;
        num = Math.floor(num / 26) - 1;
      } else {
        col = String.fromCharCode("A".charCodeAt(0) + remainder - 1) + col;
        num = Math.floor(num / 26);
      }
    }
    return col;
  };
  // 시트 스타일 편집 : 읽기전용, 고정영역
  applyCellEditStyle = (type, value, range) => {
    const ref = this.refGrid.current;
    const idx = ref.sheets.selectedIndex;
    let row, col, sr;
    if (range) {
      // 열
      if (isNaN(range)) {
        row = ref.rows.length;
        col = this.colToNum(range);
        sr = [new CellRange(0, col, row - 1, col)];
      }
      // 행
      else {
        row = range - 1;
        col = ref.columns.length;
        sr = [new CellRange(row, 0, row, col - 1)];
      }
    } else {
      sr = ref.selectedRanges;
    }
    for (let i = 0; i < sr.length; i++) {
      if (sr[i].col === sr[i].col2 && sr[i].row === sr[i].row2) {
        alert("행/열 헤더를 선택해야 합니다.");
        return;
      }
      const rowId = sr[i].row + 1;
      const colId = this.numToCol(sr[i].col);
      const temp = this.state.cellEditStyle.filter(
        (item) =>
          item.sheetIdx === idx &&
          item.type === type &&
          ((item.value === rowId && sr[i].row === sr[i].row2) || (item.value === colId && sr[i].col === sr[i].col2))
      );
      // 동일한 셀이 존재할 경우
      if (value && temp.length > 0) {
        return;
      }

      // 열을 선택한 경우
      if (sr[i].col === sr[i].col2) {
        if (type === "readOnly") ref.columns[sr[i].col].isReadOnly = value;
        if (type === "frozenCell") {
          ref.frozenColumns = value ? sr[i].col + 1 : 0;
          if (
            this.state.cellEditStyle.filter((item) => item.sheetIdx === idx && item.type === type && isNaN(item.value))
              .length > 0
          )
            this.setState((prev) => ({
              cellEditStyle: prev.cellEditStyle.filter(
                (item) => !isNaN(item.value) && item.sheetIdx === idx && item.type === type
              ),
            }));
        }
        if (value) {
          this.setState((prev) => ({
            cellEditStyle: [...prev.cellEditStyle, { sheetIdx: idx, type: type, value: colId }],
          }));
        } else {
          this.setState((prev) => ({
            cellEditStyle: prev.cellEditStyle.filter(
              (item) => item.value !== colId && item.sheetIdx === idx && item.type === type
            ),
          }));
        }
      }
      // 행을 선택한 경우
      else if (sr[i].row === sr[i].row2) {
        if (type === "readOnly") ref.rows[sr[i].row].isReadOnly = value;
        if (type === "frozenCell") {
          ref.frozenRows = value ? rowId : 0;
          if (
            this.state.cellEditStyle.filter((item) => item.sheetIdx === idx && item.type === type && !isNaN(item.value))
              .length > 0
          )
            this.setState((prev) => ({
              cellEditStyle: prev.cellEditStyle.filter(
                (item) => isNaN(item.value) && item.sheetIdx === idx && item.type === type
              ),
            }));
        }
        if (value) {
          this.setState((prev) => ({
            cellEditStyle: [...prev.cellEditStyle, { sheetIdx: idx, type: type, value: rowId }],
          }));
        } else {
          this.setState((prev) => ({
            cellEditStyle: prev.cellEditStyle.filter(
              (item) => item.value !== rowId && item.sheetIdx === idx && item.type === type
            ),
          }));
        }
      }
    }
  };

  // ### 시트 추가 로직 : 여기까지

  // DataType에 맞춰서 Data Format 처리
  makeDataType(data, format) {
    if (format.dataType === "Date" || format.dataType === "Time") {
      data.map((e, idx) => {
        return (data[idx][format.binding] = e[format.binding] ? new Date(e[format.binding]) : null);
        // return (data[idx][format.binding] = e[format.binding] ? Globalize.format(new Date(e[format.binding]), format.format) : null);
      });
    } else if (format.dataType === "Number") {
      data.map((e, idx) => {
        return (data[idx][format.binding] = e[format.binding] ? Number(e[format.binding]) : null);
        // return (data[idx][format.binding] = e[format.binding] ? Globalize.format(e[format.binding], format.format) : null);
      });
    } else if (format.dataType === "Boolean") {
      data.map((e, idx) => {
        return (data[idx][format.binding] = e[format.binding] ? true : false);
      });
    }
  }

  setIsReadOnly = (value) => {
    this.setState({
      isReadOnly: value,
    });
  };

  getIsReadOnly = () => {
    if (this.state.isReadOnly) {
      return this.state.isReadOnly;
    }
  };

  /**
   * column Setting
   * @param columns
   */
  setColumns = (columns) => {
    this.setState({
      columns: columns,
    });
  };

  /**
   * column Group Setting
   * @param colgroup
   */
  setColumngroups = (colgroup) => {
    this.setState({
      columnGroups: colgroup,
    });
    //this.refGrid.current.columnGroups.CollectionView = colgroup.CollectionView;
  };

  // 그리드 전체 데이터
  getRows = () => {
    if (this.chkArray(this.refGrid.current.rows)) {
      return this.refGrid.current.rows.map((x) => x.dataItem);
    }

    /* 2024-01-11 : this.state.data ==> this.refGrid.current.collectionView 변경 작업 백업 */
    // if (this.state.data && this.chkArray(this.state.data.items)) {
    //   return this.state.data.items;
    // }
  };

  getRowsByIndex = (idx) => {
    if (this.chkArray(this.refGrid.current.rows)) {
      return this.getRows()[idx];
    }

    /* 2024-01-11 : this.state.data ==> this.refGrid.current.collectionView 변경 작업 백업 */
    // if (this.state.data && this.chkArray(this.state.data.items)) {
    //   return this.state.data.items[idx];
    // }
  };

  getCheckedRows = () => {
    if (this.chkArray(this.refGrid.current.rows)) {
      return this.getRows().filter((e) => {
        return e[this.props.checkBoxColumn];
      });
    }

    /* 2024-01-11 : this.state.data ==> this.refGrid.current.collectionView 변경 작업 백업 */
    // if (this.state.data && this.chkArray(this.state.data.items)) {
    //   return this.state.data.items.filter((e) => {
    //     return e[this.props.checkBoxColumn];
    //   });
    // }
  };

  // 그리드 선택한 행 데이터
  getSelectedRow = () => {
    if (this.refGrid.current.collectionView) {
      return this.refGrid.current.collectionView?.currentItem;
    }

    /* 2024-01-11 : this.state.data ==> this.refGrid.current.collectionView 변경 작업 백업 */
    // if (this.state.data && this.state.data.currentItem) {
    //   return this.state.data.currentItem;
    // }
  };

  // 그리드 선택한 행 인덱스
  getSelectedRowIndex = () => {
    if (this.refGrid.current.selectedRows) {
      return this.refGrid.current.selectedRows[0]?.index;
    }

    /* 2024-01-11 : this.state.data ==> this.refGrid.current.collectionView 변경 작업 백업 */
    // if (this.state.data && this.state.data.currentItem) {
    //   return this.state.data.currentPosition;
    // }
  };

  // 그리드 rows 개수
  getRowsCount = () => {
    if (this.chkArray(this.refGrid.current.rows)) {
      return this.refGrid.current.rows.length;
    }

    /* 2024-01-11 : this.state.data ==> this.refGrid.current.collectionView 변경 작업 백업 */
    // if (this.state.data && this.chkArray(this.state.data.items)) {
    //   return this.state.data.items.length;
    // }
  };

  // 그리드 신규 추가한 데이터
  getAddedRows = () => {
    if (this.chkArray(this.refGrid.current.rows)) {
      return this.getRows().filter((x) => {
        return x.ROW_STATUS === 1;
      });
    }

    /* 2024-01-11 : this.state.data ==> this.refGrid.current.collectionView 변경 작업 백업 */
    // if (this.state.data) {
    //   return this.state.data.itemsAdded;
    // }
  };

  /// 그리드 수정한 데이터
  getEditedRows = () => {
    if (this.chkArray(this.refGrid.current.rows)) {
      return this.getRows().filter((x) => {
        return x.ROW_STATUS === 2;
      });
    }

    /* 2024-01-11 : this.state.data ==> this.refGrid.current.collectionView 변경 작업 백업 */
    // if (this.state.data) {
    //   return this.state.data.itemsEdited;
    // }
  };

  // 그리드 삭제한 데이터
  getDeletedRows = () => {
    if (this.chkArray(this.refGrid.current.rows)) {
      return this.getRows().filter((x) => {
        return x.ROW_STATUS === 4;
      });
    }

    /* 2024-01-11 : this.state.data ==> this.refGrid.current.collectionView 변경 작업 백업 */
    // if (this.state.data) {
    //   return this.state.data.itemsRemoved;
    // }
  };

  // Cell에 CSS 적용
  setToggleClass(cell, css, condition) {
    toggleClass(cell, css, condition);
  }

  // 그리드 초기화
  clear = () => {
    this.setState({
      source: null,
      columns: [],
      columnGroups: [],
    });
  };
  clearDataBinding = () => {
    this.setState({
      source: null,
    });
  };

  // 행 추가
  addRow = () => {
    // 맨마지막 행을 선택한 상태여야 행 추가시, 행 추가한 행이 화면에 보임
    const itemCount = this.getRowsCount();
    const view = this.refGrid.current.collectionView;
    view.currentPosition = itemCount - 1;

    // 행추가
    view.addNew();

    // 추가한 행의 상태는 1
    view.items[view.currentPosition].ROW_STATUS = 1;
    view.items[view.currentPosition].ROW_CHECK = true;

    // 이벤트 추가
    const e = new CellRangeEventArgs(this.refGrid.current.cells, this.refGrid.current.selection);
    this.refGrid.current.onRowAdded(e);

    return e;

    /* 2024-01-11 : this.state.data ==> this.refGrid.current.collectionView 변경 작업 백업 */
    // // 맨마지막 행을 선택한 상태여야 행 추가시, 행 추가한 행이 화면에 보임
    // var itemCount = this.state.data.itemCount;
    // this.state.data.currentPosition = itemCount - 1;

    // // 행추가
    // this.state.data.addNew();

    // // 추가한 행의 상태는 1
    // this.state.data.items[itemCount].ROW_STATUS = 1;
    // this.state.data.items[itemCount].ROW_CHECK = true;

    // // 이벤트 추가
    // let e = new CellRangeEventArgs(this.refGrid.current.cells, this.refGrid.current.selection);
    // this.refGrid.current.onRowAdded(e);

    // return e;
  };

  // 행 삭제
  /**
   * 종속된 ( gird1에 의해 grid2가 출력된 화면에서 grid2일 경우 바로 적용이 안됨(스크롤 내려갔다가 올라가면 적용됨))
   */
  deleteRow = (idx) => {
    // idx가 없는 경우 마지막행을 대상으로 함
    if (idx !== 0 && !idx) {
      idx = this.getRowsCount() - 1;
    }

    // 신규로 추가된 행에 대해서는 행삭제를 진행
    // 기존 존재하는 행에 대해서는 삭제Flag 부여
    if (this.refGrid.current.collectionView.items[idx].ROW_STATUS == 1) {
      this.refGrid.current.collectionView.removeAt(idx);
    } else {
      // 삭제Flag 부여
      this.refGrid.current.collectionView.items[idx].ROW_STATUS = 4;
      this.refGrid.current.collectionView.items[idx].ROW_CHECK = true;
      this.viewUpdates();
    }

    // 이벤트 추가
    let e = new CellRangeEventArgs(this.refGrid.current.cells, this.refGrid.current.selection);
    this.refGrid.current.onDeletingRow(e);

    return e;

    /* 2024-01-11 : this.state.data ==> this.refGrid.current.collectionView 변경 작업 백업 */
    // // idx가 없는 경우 마지막행을 대상으로 함
    // if (idx > 0) {
    // } else if (this.state.data.currentPosition > -1) {
    //   idx = this.state.data.currentPosition;
    // } else {
    //   return;
    // }

    // // 신규로 추가된 행에 대해서는 행삭제를 진행
    // // 기존 존재하는 행에 대해서는 삭제Flag 부여
    // if (this.state.data.items[idx].ROW_STATUS == 1) {
    //   this.state.data.removeAt(idx);
    // } else {
    //   // 삭제Flag 부여
    //   this.state.data.items[idx].ROW_STATUS = 4;
    //   this.state.data.items[idx].ROW_CHECK = true;
    //   this.viewUpdates();
    // }

    // // 이벤트 추가
    // let e = new CellRangeEventArgs(this.refGrid.current.cells, this.refGrid.current.selection);
    // this.refGrid.current.onDeletingRow(e);
  };

  // 그리드 선택 취소
  clearSelection = () => {
    if (this.refGrid.current?.collectionView) {
      this.refGrid.current.collectionView?.moveCurrentToPosition(-1);
    }

    /* 2024-01-11 : this.state.data ==> this.refGrid.current.collectionView 변경 작업 백업 */
    // if (this.state.data) {
    //   this.state.data.moveCurrentToPosition(-1);
    // }
  };

  // 그리드 신규 추가한 행 전부 삭제
  clearAddRows = () => {
    if (this.chkArray(this.refGrid.current.rows)) {
      this.getRows().map((e) => {
        if (e.ROW_STATUS === 1) return this.refGrid.current.collectionView?.remove(e);
      });
    }

    /* 2024-01-11 : this.state.data ==> this.refGrid.current.collectionView 변경 작업 백업 */
    // if (this.state.data && this.chkArray(this.state.data.itemsAdded)) {
    //   this.state.data.itemsAdded.map((e) => {
    //     return this.state.data.remove(e);
    //   });
    // }
  };

  // 배열 체크
  chkArray(arr) {
    if (arr && arr.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  // validation
  // dataRowIndex : 데이터 시작 행 인덱스, headerRowIndex : 헤더로 사용되고 있는 행 인덱스
  async chkValidate(ymlFile, dataRowIndex, headerRowIndex) {
    const validateInfo = await getObjectFromYml(ymlFile);
    //this.setState({ validateInfo: validateInfo });
    let returnArray = [];
    const sheet = this.refGrid.current.selectedSheet;
    const rowCnt = this.getRowsCount() - 1;
    const colCnt = sheet._flex.columns.length;

    for (let i = dataRowIndex; i < rowCnt; i++) {
      for (let j = 0; j < colCnt; j++) {
        const cols = sheet._flex.columns;
        const colId = cols[j].binding;
        const colName = !isNaN(headerRowIndex) ? sheet.itemsSource.items[headerRowIndex][colId] : cols[j].header;
        const value = sheet.itemsSource.items[i][colId];
        const validInfo = validateInfo[colId];
        // yml 파일의 컬럼 ID와 현재 셀의 컬럼 ID가 동일하면 validate() 수행
        if (validInfo) {
          // validate() 수행 시 error를 throw하므로 try catch를 사용하여 ERR_MSG 컬럼에 값 바인딩
          try {
            validate(getValidateObject(validInfo, colName, value));
          } catch (ex) {
            //console.log("########## 오류 ############ ["+String(i + 1)+"]번째 행 ", ex)
            const exsplit = String(ex).split(":");
            returnArray.push({
              row: i + 1,
              col: colId,
              colNm: colName,
              msg: exsplit[exsplit.length - 1],
            });
          }
        }
      }
    }
    return returnArray;
  }

  // dataRowIndex : 데이터 시작 행 인덱스, headerRowIndex : 헤더로 사용되고 있는 행 인덱스
  chkValidate2(ymlFile, dataRowIndex, headerRowIndex) {
    getObjectFromYml(ymlFile).then((res) => {
      this.setState({ validateInfo: res }, () => {
        let returnArray = [];
        const sheet = this.refGrid.current.selectedSheet;
        const rowCnt = this.getRowsCount() - 1;
        const colCnt = sheet._flex.columns.length;

        for (let i = dataRowIndex; i < rowCnt; i++) {
          for (let j = 0; j < colCnt; j++) {
            const cols = sheet._flex.columns;
            const colId = cols[j].binding;
            const colName = !isNaN(headerRowIndex) ? sheet.itemsSource.items[headerRowIndex][colId] : cols[j].header;
            const value = sheet.itemsSource.items[i][colId];
            const validInfo = this.state.validateInfo[colId];
            // yml 파일의 컬럼 ID와 현재 셀의 컬럼 ID가 동일하면 validate() 수행
            if (validInfo) {
              // validate() 수행 시 error를 throw하므로 try catch를 사용하여 ERR_MSG 컬럼에 값 바인딩
              try {
                validate(getValidateObject(validInfo, colName, value));
              } catch (ex) {
                console.log("########## 오류 ############ [" + String(i + 1) + "]번째 행 ", ex);
                returnArray.push(ex);
                //sheet.itemsSource.items[i].ERR_MSG = ex;
                //returnValue = false;
              }
            }
          }
        }

        return returnArray;
      });
    });
  }

  setFlatColumnGroups(columnGroups) {
    if (columnGroups.length == 0) return [];
    var prev = columnGroups[0];
    var next = columnGroups.length === 1 ? [] : columnGroups.slice(1);
    if (Array.isArray(prev.columns)) {
      return this.setFlatColumnGroups(prev.columns.concat(next));
    } else {
      return [prev].concat(this.setFlatColumnGroups(next));
    }
  }

  // 컬럼 그룹 auto width & align center 지정
  settingColumnGroups(columnGroups) {
    columnGroups.map((column) => {
      if (this.chkArray(column.columns)) {
        column.columns.map((col) => {
          this.settingColumnGroupsCommon(col);
        });
      } else {
        column.align = column.align ? column.align : "center";
        this.settingColumnGroupsCommon(column);
      }
    });
    return columnGroups;
  }

  // columns와 동일한 로직 구성
  // settingColumnGroups 함수에서 호출함
  settingColumnGroupsCommon(column) {
    column.width = column.width ? column.width : "*";

    if (column.editor) {
    } else {
      column.editor = column.dataType?.inputColor
        ? new InputColor(document.createElement("div"))
        : column.isTime
        ? new InputTime(document.createElement("div"), {
            format: column.format,
            step: column.timeStep,
          })
        : column.dataType == "Date"
        ? new InputDate(document.createElement("div"))
        : column.dataMap
        ? !(column.dataMapEditor === "RadioButtons")
          ? new AutoComplete(document.createElement("div"), {
              itemsSource: column.dataMap,
              selectedValuePath: column.dataMapCode,
              displayMemberPath: column.dataMapValue,
            })
          : null
        : null;
      delete column.isTime;
      delete column.timeStep;
    }

    if (column.dataMapCode) {
      column.dataMap = new DataMap(column.dataMap, column.dataMapCode, column.dataMapValue);
      delete column.dataMapCode;
      delete column.dataMapValue;
    }

    if (column.cellTemplate) {
    } else {
      if (column.dataType?.inputColor) {
        column.cellTemplate = '<span class="colorbox" style="background:${text};"></span> ${text}';
      } else if (column.isButton) {
        const cloneEvent = column.clickEvent;
        column.cellTemplate = CellMaker.makeButton({
          click: (e, ctx) => {
            cloneEvent(e, ctx);
          },
        });
        delete column.isButton;
      } else if (column.isImage) {
        const cloneEvent = column.clickEvent;
        column.cellTemplate = CellMaker.makeImage({
          click: (e, ctx) => {
            cloneEvent(e, ctx);
          },
        });
        delete column.isImage;
      } else if (column.isLink) {
        const cloneEvent = column.clickEvent;
        column.cellTemplate = CellMaker.makeLink({
          click: (e, ctx) => {
            cloneEvent(e, ctx);
          },
        });
        delete column.isLink;
      }
      delete column.clickEvent;
    }

    if (column.exceptChkValue) {
      /**
       * 그룹 컬럼일 경우 처리 방식 구현 필요
       * FlexSheet.formatItem.addHandler() 함수 추가 구현 필요
       */
      delete column.exceptChkValue;
    }
  }

  forceUpdates = () => {
    this.setState({ data: this.getRows() });
    this.forceUpdate();
  };

  // forceUpdates를 하는 경우, data의 값이 json형태의 데이터로 교체가 됨 (setDataBinding에서는 CollectionView임)
  // CollectionView가 필요하여 viewUpdates를 추가함.
  // 추가로 currentPosition 값을 기억하게 하여 data 바인딩 후 적용함
  viewUpdates = (callback) => {
    var currentPosition = this.getSelectedRowIndex();
    let bindingData = this.getRows();
    this.setState(
      {
        source: bindingData,
        data: new CollectionView(bindingData, {
          sortDescriptions: this.state.sortDescriptions,
          groupDescriptions: this.state.groupDescriptions,
          trackChanges: this.state.trackChanges,
        }),
      },
      () => {
        this.refGrid.current.collectionView.currentPosition = currentPosition;
        return callback ? callback(this) : null;
      }
    );

    /* 2024-01-11 : this.state.data ==> this.refGrid.current.collectionView 변경 작업 백업 */
    // var currentPosition = this.state.data.currentPosition;
    // let bindingData = this.state.data._view;
    // this.setState(
    //   {
    //     source: bindingData,
    //     data: new CollectionView(bindingData, {
    //       sortDescriptions: this.state.sortDescriptions,
    //       groupDescriptions: this.state.groupDescriptions,
    //       trackChanges: this.state.trackChanges,
    //     }),
    //   },
    //   () => {
    //     this.state.data.currentPosition = currentPosition;
    //     return callback ? callback(this) : null;
    //   }
    // );
  };

  // 행 고정
  freezeRows = () => {
    if (this.refGrid.current) {
      this.refGrid.current.frozenRows = this.refGrid.current.frozenRows > 0 ? 0 : this.state.frozenRows;
    }
  };

  // 열 고정
  freezeColumns = () => {
    if (this.refGrid.current) {
      this.refGrid.current.frozenColumns = this.refGrid.current.frozenColumns > 0 ? 0 : this.state.frozenColumns;
    }
  };

  // 생선된 CellMaker 선택적 제거
  removeCellMaker = (s, e) => {
    /**
     * gird 내 button 사용 시, 조건에 맞지 않으면 버튼 제거
     * 향후 link, image에도 필요시 적용 필요
     *
     * init
     */
    const result = this.state.columns.filter((x) => {
      return x.exceptChkValue;
    });

    // 제외할 목록이 존재 시,
    if (result && result.length) {
      result.map((x) => {
        if (x.binding === s.columns[e.col].binding) {
          let item = s.rows[e.row].dataItem;

          // 제거 유무의 조건이 맞는지 체크 : return only true value
          const exceptChkValue =
            result.length > 0
              ? Object.entries(x.exceptChkValue)
                  .map(([key, value]) => {
                    return item[key] === value;
                  })
                  .filter((x) => x === true)
              : null;

          // key : value 비교했을때, 제외(true)하는 대상이라면
          if (exceptChkValue && exceptChkValue.length > 0) {
            // element가 있는지 체크
            if (e.cell.childElementCount > 0) {
              switch (e.cell.lastChild.nodeName) {
                case "BUTTON":
                  e.cell.innerHTML = s.getCellData(e.row, e.col);
                  break;
                default:
                  break;
              }
            }
          }
        }
      });
    }
    /**
     * gird 내 button 사용 시, 조건에 맞지 않으면 버튼 제거
     * 향후 link, image에도 필요시 적용 필요
     *
     * end
     */
  };

  // Grid Header Style 적용
  addHeaderStyle = (e) => {
    if (this.props.headerStyle?.length) {
      let row = e.row;
      let col = e.col;

      this.props.headerStyle.forEach((x) => {
        if (x.row === row && x.col === col) {
          // if (x.header === e.panel.getCellData(e.row, e.col)) {
          x.className?.forEach((name) => {
            // e.cell.style.setProperty(v.key, v.value);
            this.setToggleClass(e.cell, name, true);
          });
        }
      });
    }
  };

  // Grid Header MultiLine 적용
  headerMultiLine = (e) => {
    // if (this.props.isAutoRowHeights) {
    //   e.cell.innerHTML = e.cell.textContent;
    //   // filter icon
    //   if (this.state.filter) {
    //     const filterIcon = `<div style="width:auto;float:right;" role="button" class="wj-elem-filter wj-filter-off"><span class="wj-glyph-filter"></span></div>`;
    //     // const filterIcon = `<button class="wj-btn wj-btn-glyph wj-right wj-elem-filter" type="button" tabindex="-1" aria-label="열에 대한 필터를 편집  " aria-haspopup="dialog" aria-expanded="false" aria-pressed="false"><span class="wj-glyph-filter"></span></button>`;
    //     e.cell.innerHTML += filterIcon;
    //   }
    //   // pin icon
    //   if (this.state.allowPinning) {
    //     const pinningIcon = `<div style="width:auto;float:right;margin-right: 5px;" role="button" class="wj-elem-pin wj-filter-off"><span class="wj-glyph-pin"></span></div>`;
    //     // const pinningIcon = `<button class="wj-btn wj-btn-glyph wj-right wj-elem-pin wj-state-pinned" type="button" tabindex="-1" aria-pressed="true"><span class="wj-glyph-pin"></span></button>`;
    //     e.cell.innerHTML += pinningIcon;
    //   }
    // }
  };

  /**
   * FlexSheet 관련 함수
   *
   * end
   */

  /**
   * Excel 관련 함수
   *
   * init
   */

  /**
   *
   * @param {Boolean} colHeader colHeader 생성 여부
   * @param {Boolean} style style 적용 여부
   * @param {*} fileName 파일 이름
   * @param {Boolean} isCheckedItem 체크된 항목 export 여부
   * 엑셀 Export
   *
   */
  saveExcel = (colHeader, style, fileName, isCheckedItem = false) => {
    const copyGrid = _.cloneDeep(this.refGrid.current);
    if (isCheckedItem) {
      const trueValue = copyGrid.itemsSource.filter((x) => {
        return x.ROW_CHECK === true;
      });

      copyGrid.itemsSource = trueValue;
    }

    wjcGridXlsx.FlexGridXlsxConverter.saveAsync(
      copyGrid,
      {
        includeColumnHeaders: colHeader,
        includeStyles: style,
        includeColumns: function (column) {
          return column.binding !== "ROW_CHECK" && column.binding !== "ROW_STATUS";
        },
      },
      fileName > "" ? fileName : "FlexSheet.xlsx"
    );

    copyGrid.itemsSource = this.refGrid.current.itemsSource;
  };

  // 엑셀 Import
  // 그리드 컨트롤에 input 태그를 포함하고, wjcGridXlsx.FlexGridXlsxConverter.loadAsync 의 문제로 인해 loadExcel 함수 자체를 변경함
  // loadExcel = (file, rowHeader, colHeader) => {
  //   wjcGridXlsx.FlexGridXlsxConverter.loadAsync(this.refGrid.current, file, {
  //     includeColumnHeaders: colHeader,
  //     includeRowHeaders: rowHeader,
  //   });
  //   //his.loadExcelMakeGridData(file);
  // };
  loadExcel = (headeRangeIdx = 0) => {
    this.useRefInput.current["headeRangeIdx"] = headeRangeIdx;
    this.useRefInput.current.click();
  };

  loadExcelMakeGridData = async (file) => {
    //wjcGridXlsx.FlexGridXlsxConverter.loadAsync(this.FlexSheet, file, { includeColumnHeaders: colHeader, includeRowHeaders: rowHeader });
    let grid = this.refGrid.current;
    let _workbook = new wjcXlsx.Workbook();
    _workbook.loadAsync(file, (workbook) => {
      let headeRangeIdx = this.useRefInput.current["headeRangeIdx"];
      let sheet = workbook.sheets[0];
      let excelRow = sheet.rows[0];
      let newData = this.getImportedDataFromWorkSheet(sheet, grid, headeRangeIdx);

      // newData 구조가 헤더명:값 으로 되어 있어, 헤더명을 컬럼ID로 변경함
      let arrData = new Array();
      const gridColumnsCopy = _.cloneDeep(grid._cols).filter((x) => {
        return x.binding !== "ROW_CHECK" && x.binding !== "ROW_STATUS";
      });

      for (let i = 0; i < newData.length; i++) {
        let j = 0;
        let objData = new Object();

        for (let val in newData[i]) {
          // 엑셀 데이터에 '가 있는경우 제거
          let value = newData[i][val];
          value = typeof value == "string" ? (value.substring(0, 1) === "'" ? value.substring(1) : value) : value;

          objData[gridColumnsCopy[j]?.binding] = value;
          j++;
        }
        arrData.push(objData);
      }

      //grid.collectionView.itemsSource = newData;
      this.state.source = arrData;
      this.setDataBinding(arrData);
      if (this.useRefInput.current.value !== null) this.useRefInput.current.value = "";
    });
  };

  getImportedDataFromWorkSheet(worksheet, FlexSheet, headeRangeIdx = 0) {
    const idx = headeRangeIdx;
    let columns = FlexSheet.columns;
    let data = [],
      workSheetRows = worksheet.rows.slice(idx + 1);
    // let rowHeader = worksheet.rows[0].cells;
    let rowHeader = [];
    for (let i = 0; i < idx + 1; i++) {
      let cells = worksheet.rows[i].cells;
      for (let j = 0; j < cells.length; j++) {
        if (cells[j]?.value) {
          rowHeader[j] = cells[j];
        }
      }
    }

    let cellMergeTmp = [];

    workSheetRows.forEach((drow) => {
      let cells = drow.cells,
        _item = {};

      // 배열의 null 값 제거
      let chkArr = cellMergeTmp.filter(Boolean);

      if (!chkArr.length) {
        // cell에 rowSpan이 존재한다면 temp에 넣어줌
        cells.forEach((x, idx) => {
          if (x.rowSpan) {
            cellMergeTmp[idx] = {
              rowSpan: x.rowSpan,
              rowSpanCnt: 0,
              value: x.value,
            };
          }
        });
      }

      rowHeader.forEach((row, i) => {
        // rowSpan (merge) 가 존재할 경우
        if (cellMergeTmp[i]) {
          // rowSpanCnt를 했을때 아직까지 merge 대상일 경우
          if (cellMergeTmp[i]?.rowSpan !== cellMergeTmp[i]?.rowSpanCnt) {
            // 해당 행에 데이터를 넣어줌 (temp에 담아놓은 데이터)
            // ∵ 엑셀에 merge되어있을경우 merge된 셀에 데이터는 하나밖에 없기 때문에 모든 row에 같은 값을 넣어줌
            // e3 framework에서는 같은 값일 경우 merge하는 기능이 존재
            _item[row.value] = cellMergeTmp[i]?.value;
            cellMergeTmp[i].rowSpanCnt = cellMergeTmp[i].rowSpanCnt + 1;
          }

          // merge 대상이 끝났다면 삭제를 위한 null 셋팅
          if (cellMergeTmp[i]?.rowSpan === cellMergeTmp[i]?.rowSpanCnt) {
            cellMergeTmp[i] = null;
          }
        } else {
          _item[row.value] = cells[i]?.value;
        }
      });
      data.push(_item);
    });
    return data;
  }

  /**
   * Excel 관련 함수
   *
   * end
   */
}

E3WijmoSheet.propTypes = {
  style: PropTypes.object,
  theme: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  columns: PropTypes.array.isRequired,
  columnGroups: PropTypes.array,
  allowAddNew: PropTypes.bool,
  allowDelete: PropTypes.bool,
  selectionMode: PropTypes.string,
  onRowClick: PropTypes.func,
  onRowDoubleClick: PropTypes.func,
  sortDescriptions: PropTypes.array,
  groupDescriptions: PropTypes.array,
  trackChanges: PropTypes.bool,
  filter: PropTypes.bool,
  quickAutoSize: PropTypes.bool,
  allowPinning: PropTypes.string,
  isNo: PropTypes.bool,
  codeId: PropTypes.string,
  frozenRows: PropTypes.number,
  frozenColumns: PropTypes.number,
  allowMerging: PropTypes.string,
  isReadOnly: PropTypes.bool,
  exportExcel: PropTypes.bool,
  defaultColumn: PropTypes.bool,
  onCellUpdate: PropTypes.func,
  onCellEditEnding: PropTypes.func,
  onCellEditEnded: PropTypes.func,
  onRowAdded: PropTypes.func,
  onDeletingRow: PropTypes.func,
  beginningEdit: PropTypes.func,
  sortedColumn: PropTypes.func,
  isAllCheckbox: PropTypes.bool,
  checkBoxColumn: PropTypes.string,
  validateYmlFile: PropTypes.string,
  gridId: PropTypes.string,
  childItemsPath: PropTypes.string,
  isCollapseGroupsToLevel0: PropTypes.bool,
  onloadedRows: PropTypes.func,
  onFormatItem: PropTypes.func,
  isColumnFooters: PropTypes.bool,
  isInputFilter: PropTypes.bool,
  isSearchFilter: PropTypes.object,
  isDragColumn: PropTypes.bool,
  isAutoRowHeights: PropTypes.bool,
  headerStyle: PropTypes.array,
  columnFooterName: PropTypes.object,
  onSelectedSheetChanged: PropTypes.func,
  onSaveStyle: PropTypes.func,
};

E3WijmoSheet.defaultProps = {
  width: "100%",
  height: "100%",
  columns: [],
  columnGroups: [],
  allowAddNew: true,
  allowDelete: true,
  selectionMode: "Cell",
  onRowClick: null,
  onRowDoubleClick: null,
  sortDescriptions: [],
  groupDescriptions: [],
  trackChanges: true,
  filter: false,
  quickAutoSize: true,
  allowPinning: "",
  isNo: true,
  frozenRows: 0,
  frozenColumns: 0,
  allowMerging: "Cells",
  isReadOnly: true,
  exportExcel: false,
  defaultColumn: true,
  onCellUpdate: null,
  onCellEditEnding: null,
  onCellEditEnded: null,
  onRowAdded: null,
  onDeletingRow: null,
  beginningEdit: null,
  sortedColumn: null,
  isAllCheckbox: false,
  checkBoxColumn: "CHK",
  validateYmlFile: null,
  gridId: null,
  childItemsPath: null,
  isCollapseGroupsToLevel0: false,
  onloadedRows: null,
  onFormatItem: null,
  isColumnFooters: false,
  isInputFilter: false,
  isSearchFilter: null,
  isDragColumn: false,
  isAutoRowHeights: false,
  headerStyle: [],
  columnFooterName: {},
  onSelectedSheetChanged: null,
  onSaveStyle: null,
};

class RestrictedMergeManager extends wjGrid.MergeManager {
  getMergedRange(p, r, c, clip = true) {
    if (r < 0) return;

    // create basic cell range
    var rng = null;

    // 머지 대상만 머지 함
    if (!p.columns[c].allowMerging) return rng;

    // start with single cell
    rng = new wjGrid.CellRange(r, c);
    var pcol = c > 0 ? c - 1 : c;

    // get reference values to use for merging
    var val = p.getCellData(r, c, false);
    var checkCols = (dir) => {
      var tempCheck = (dir, val, idx) => {
        for (var j = 0; j < idx + 1; j++) {
          var tval = dir == "up" ? p.getCellData(rng.row - 1, j, false) : p.getCellData(rng.row2 + 1, j, false);
          if (tval != val) return true;
        }
        return false;
      };

      var state = true;
      for (var i = 0; i < c - 1; i++) {
        var cval = p.getCellData(r, i, false);
        var bcval = dir == "up" ? p.getCellData(rng.row - 1, i, false) : p.getCellData(rng.row2 + 1, i, false);
        //console.log(r, c, i, val, cval, bcval)
        //if (p.columns[i].allowMerging && bcval != cval) {
        if (p.columns[i].allowMerging && tempCheck(dir, val, i)) {
          state = false;
          break;
        }
      }
      return state;
    };

    // expand left/right
    for (var i = rng.col; i < p.columns.length - 1; i++) {
      if (!p.columns[i].allowMerging) break;
      if (p.getCellData(rng.row, i, true) != p.getCellData(rng.row, i + 1, true)) break;
      rng.col2 = i + 1;
    }
    for (var i = rng.col; i > 0; i--) {
      if (!p.columns[i].allowMerging) break;
      if (p.getCellData(rng.row, i, true) != p.getCellData(rng.row, i - 1, true)) break;
      rng.col = i - 1;
    }

    // expand up
    while (rng.row > 0 && p.getCellData(rng.row - 1, c, false) == val && checkCols("up")) {
      rng.row--;
    }

    // // expand down
    while (rng.row2 < p.rows.length - 1 && p.getCellData(rng.row2 + 1, c, false) == val && checkCols("down")) {
      rng.row2++;
    }

    // don't bother with single-cell ranges
    if (rng.isSingleCell) {
      rng = null;
    }

    // done
    return rng;
  }
}

export default E3WijmoSheet;
